import "./vendor/slick/slick.js";
// import AOS from "./vendor/aos/dist/aos.js";
import "bootstrap";
import "./blocks/slideshows.js";
import "./blocks/gallery.js";
import "./blocks/timeline.js";
import "./blocks/navigation.js";
import "./blocks/forms.js";
import "./elements/pull-out-contact.js";

$(function() {
    // let footerHeight = $(".footer").outerHeight();
	// $("main").css("margin-bottom", footerHeight);

    $('.hero__scroll a').on('click', function(e) {
        e.preventDefault();
        const target = $(e.currentTarget).data('target');
        $('html,body').animate({
            scrollTop: ($(target).offset().top + $(target).outerHeight())
        }, 1500);
    });
});

$(window).on('load', function() {
    outdatedBrowser({
        bgColor: '#f25648',
        color: '#ffffff',
        lowerThan: 'borderImage',
        languagePath: ''
    });
    if (!$("body").hasClass("page-edit-mode")) {
        // AOS.init({
        //     offset: 200,
        //     delay: 50,
        //     duration: 1000,
        //     easing: "ease-in-out",
        //     once: false,
        // });
        // AOS.refresh();
    }
    $('body').addClass('loaded');
});

$(document).on('click', ".navigation__screen--content .dropdown-toggle", (e) => {
    e.stopPropagation();
    $(this).parent().toggleClass('open');
});

$(window).on('scroll', function () {
    if ($(this).scrollTop() > 100) {
        $(".header").addClass("sticky");
    } else {
        $(".header").removeClass("sticky");
    }
});
